module.exports = __webpack_public_path__ + "static/vmno-streaming-now-tallyman.v1-click2sms/files/edebad57d9fd3fc50053b4196f70af2d.mp4";